module.exports = __webpack_public_path__ + "img/Rectangle 7544.c7b87ca5.png";